<template>
  <div class="pp-wrap">
    <div class="pp-brand"><h1>💳 Pay your bill</h1><div class="pp-sub" v-if="invoice">{{ invoice.hospital_name }}</div></div>
    <div v-if="error" class="pp-err">{{ error }}</div>
    <div v-if="invoice" class="pp-amount">
      <div class="pp-lbl">Amount Due</div>
      <div class="pp-big"><span class="pp-cur">KES</span>{{ formatMoney(invoice.balance) }}</div>
      <div><span class="pp-badge" :class="'st-' + invoice.payment_status">{{ (invoice.payment_status||'').toUpperCase() }}</span></div>
    </div>
    <div v-if="invoice" class="pp-card">
      <div class="pp-row"><span class="k">Invoice</span><span class="v mono">{{ invoice.invoice_number }}</span></div>
      <div class="pp-row"><span class="k">Patient</span><span class="v">{{ invoice.patient_name }}<span v-if="invoice.patient_no"> ({{ invoice.patient_no }})</span></span></div>
      <div class="pp-row" v-if="invoice.invoice_date"><span class="k">Date</span><span class="v">{{ (invoice.invoice_date||'').slice(0,10) }}</span></div>
    </div>
    <div v-if="items.length" class="pp-card">
      <div class="pp-lbl">Line Items</div>
      <div v-for="(it, i) in items" :key="i" class="pp-line">
        <span>{{ it.item_description }} × {{ Number(it.quantity) }}</span>
        <span class="muted">KES {{ formatMoney(it.total_price) }}</span>
      </div>
    </div>
    <div v-if="invoice && parseFloat(invoice.balance) <= 0" class="pp-paid">
      <div>✓ Payment received — thank you.</div>
      <div class="muted">This invoice has been settled.</div>
    </div>
    <div v-else-if="invoice" class="pp-card">
      <label>M-Pesa Phone Number</label>
      <input type="tel" v-model="phone" placeholder="07XX XXX XXX" inputmode="numeric" />
      <div class="muted">Pay for yourself or someone else. STK prompt goes to this number.</div>
      <button class="pp-btn" :disabled="busy" @click="pay">{{ busy ? 'Sending…' : 'Pay KES ' + Math.floor(invoice.balance) }}</button>
      <div v-if="statusMsg" :class="['pp-status', statusKind]"><span>{{ statusMsg }}</span></div>
    </div>
    <div class="pp-foot">Secured by Safaricom M-Pesa</div>
  </div>
</template>

<script>
/* eslint-disable */
import { executeJson, hms } from "@/api";
export default {
  name: "PayPublic",
  data() { return { invoice: null, items: [], error: '', phone: '', busy: false, statusMsg: '', statusKind: 'pending', checkoutId: null, polling: false }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      var token = this.$route.params.token;
      if (!token || token.length !== 32) { this.error = 'Invalid pay link.'; return; }
      try {
        var r = await executeJson({ function: 'getInvoiceByPayToken', t: token }, hms);
        if (!r.data || !r.data.success) { this.error = (r.data && r.data.message) || 'Pay link not found.'; return; }
        this.invoice = r.data.data.invoice;
        this.items   = r.data.data.items || [];
      } catch (e) { this.error = 'Could not load invoice.'; }
    },
    formatMoney(v) { return Number(v || 0).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    async pay() {
      if (!/^(?:\+?254|0)(?:7|1)\d{8}$/.test((this.phone || '').replace(/\s+/g, ''))) {
        this.setStatus('Enter a valid Kenyan phone.', 'bad'); return;
      }
      this.busy = true;
      this.setStatus('Sending STK push to ' + this.phone + '…', 'pending');
      try {
        var r = await executeJson({ function: 'publicInvoiceStk', t: this.$route.params.token, phone: this.phone }, hms);
        if (!r.data || !r.data.success) { this.setStatus('❌ ' + ((r.data && r.data.message) || 'STK failed'), 'bad'); this.busy = false; return; }
        this.checkoutId = r.data.data && r.data.data.checkout_request_id;
        if (!this.checkoutId) { this.setStatus('No checkout id — cannot track', 'bad'); this.busy = false; return; }
        this.setStatus('📲 Check your phone — enter your M-Pesa PIN within 90s.', 'pending');
        this.poll();
      } catch (e) { this.setStatus('Connection error.', 'bad'); this.busy = false; }
    },
    async poll() {
      if (this.polling) return;
      this.polling = true;
      var tries = 0;
      var tick = async () => {
        tries++;
        if (tries > 35) { this.setStatus('⌛ Timed out — refresh to try again.', 'bad'); this.polling = false; this.busy = false; return; }
        try {
          var r = await executeJson({ function: 'publicStkStatus', t: this.$route.params.token, checkout_request_id: this.checkoutId }, hms);
          var d = r.data && r.data.data;
          if (!d) { setTimeout(tick, 3000); return; }
          if (d.status === 'success')  { this.setStatus('✅ Payment received! Receipt ' + d.mpesa_receipt + ' · KES ' + d.amount, 'ok'); this.polling = false; setTimeout(() => this.load(), 1500); return; }
          if (d.status === 'cancelled'){ this.setStatus('🚫 Cancelled on phone.', 'bad'); this.polling = false; this.busy = false; return; }
          if (d.status === 'failed')   { this.setStatus('❌ ' + (d.human_message || 'Payment failed'), 'bad'); this.polling = false; this.busy = false; return; }
          if (d.status === 'timeout')  { this.setStatus('⌛ No response from phone.', 'bad'); this.polling = false; this.busy = false; return; }
          this.setStatus('📲 ' + (d.human_message || 'Waiting for PIN…') + ' (' + (d.seconds_since_initiated || 0) + 's)', 'pending');
          setTimeout(tick, 3000);
        } catch (e) { setTimeout(tick, 3000); }
      };
      setTimeout(tick, 3000);
    },
    setStatus(msg, kind) { this.statusMsg = msg; this.statusKind = kind; }
  }
};
</script>

<style scoped>
.pp-wrap { max-width: 520px; margin: 0 auto; padding: 20px 16px 60px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif; color: #1a1a1a; background: #F4F6F9; min-height: 100vh; }
.pp-brand { background: #0047AB; color: #fff; border-radius: 14px; padding: 18px 22px; margin-bottom: 14px; }
.pp-brand h1 { margin: 0; font-size: 18px; }
.pp-sub { font-size: 12px; opacity: .9; margin-top: 4px; }
.pp-card { background: #fff; border: 1px solid #E0E6ED; border-radius: 12px; padding: 18px; margin-bottom: 12px; }
.pp-amount { background: linear-gradient(135deg,#fff,#f9fbff); border: 1px solid #E0E6ED; border-radius: 14px; padding: 24px; text-align: center; margin-bottom: 12px; }
.pp-lbl { font-size: 11px; letter-spacing: 1.5px; color: #777; text-transform: uppercase; margin-bottom: 6px; }
.pp-big { font-size: 36px; font-weight: 800; color: #0047AB; line-height: 1.1; }
.pp-cur { font-size: 14px; color: #777; margin-right: 4px; }
.pp-row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 14px; border-bottom: 1px dashed #E0E6ED; }
.pp-row:last-child { border-bottom: none; }
.pp-row .k { color: #777; }
.pp-row .v.mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
.pp-line { display: flex; justify-content: space-between; font-size: 13px; padding: 6px 0; border-bottom: 1px dotted #E0E6ED; }
.pp-line:last-child { border-bottom: none; }
.muted { color: #777; font-size: 12px; }
.pp-paid { background: rgba(40,167,69,.1); color: #28a745; border: 1px solid rgba(40,167,69,.3); border-radius: 10px; padding: 20px; text-align: center; }
label { display: block; font-size: 11px; letter-spacing: 1px; color: #777; text-transform: uppercase; margin-bottom: 6px; }
input[type=tel] { width: 100%; padding: 14px; font-size: 17px; border: 1.5px solid #E0E6ED; border-radius: 10px; outline: none; }
input[type=tel]:focus { border-color: #0047AB; }
.pp-btn { width: 100%; padding: 16px; margin-top: 14px; background: #0047AB; color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; }
.pp-btn:disabled { background: #aaa; cursor: not-allowed; }
.pp-status { padding: 14px; border-radius: 10px; margin-top: 12px; font-size: 14px; }
.pp-status.pending { background: rgba(245,158,11,.1); color: #92560f; border: 1px solid rgba(245,158,11,.3); }
.pp-status.ok      { background: rgba(40,167,69,.1); color: #28a745; border: 1px solid rgba(40,167,69,.3); }
.pp-status.bad     { background: rgba(220,53,69,.1); color: #dc3545; border: 1px solid rgba(220,53,69,.3); }
.pp-err { background: rgba(220,53,69,.1); color: #dc3545; border: 1px solid rgba(220,53,69,.3); padding: 16px; border-radius: 10px; }
.pp-badge { display: inline-block; padding: 3px 10px; border-radius: 50px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; }
.pp-badge.st-paid    { background: rgba(40,167,69,.15); color: #28a745; }
.pp-badge.st-partial { background: rgba(0,71,171,.1); color: #0047AB; }
.pp-badge.st-unpaid  { background: rgba(245,158,11,.15); color: #f59e0b; }
.pp-foot { text-align: center; font-size: 11px; color: #777; margin-top: 18px; }
</style>
